import cx from 'classnames';
import { cutUrl } from 'lib/library';
import { navigation_clinic, navigation_lab, navigationSub, pageUrl } from 'lib/mapper';
import React, { Fragment, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { color } from 'styles/utils';
import {
  icon_forward_thin,
  icon_facebook,
  icon_instagram,
  icon_linkedin,
  icon_youtube,
  img_logo_S,
  icon_nav_on_kpi,
  icon_nav_kpi,
} from 'components/base/images';
import { headerHeight } from '../header/AppHeader';
import { useShallowAppSelector } from 'store/hooks';
import {
  isMasterLevelUserSelector,
  isManagerLevelUserSelector,
  isNormalLevelUserSelector,
  isClinicUserSelector,
} from 'store/modules/user';
import T from 'components/common/text/T';
import { ENV_MODE_DEV, ENV_MODE_PROD } from 'lib/setting';
import ScanProcessContainer from 'containers/util/ScanProcessContainer';
import { logoMapper } from 'lib/clinic/mapper';
import { oemState } from 'lib/store';

const AppNav = () => {
  const {
    user,
    newNotificationData: { newNotificationList },
    isMasterLevelUser,
    isManagerLevelUser,
    isNormalLevelUser,
    isClinicUser,
  } = useShallowAppSelector(state => ({
    user: state.user.user,
    newNotificationData: state.notification.newNotifications.data || {},
    isMasterLevelUser: isMasterLevelUserSelector(state),
    isManagerLevelUser: isManagerLevelUserSelector(state),
    isNormalLevelUser: isNormalLevelUserSelector(state),
    isClinicUser: isClinicUserSelector(state),
  }));
  const { pathname } = useLocation();
  const navigation = isClinicUser ? navigation_clinic : navigation_lab;

  return (
    <Styled.AppNav data-component-name="AppNav">
      <h1 className="sr-only">메인 메뉴</h1>
      <ul className="appNav__menu_list main">
        <li className="appNav__logo_box">
          <img src={logoMapper[`${oemState()}_small`]} />
        </li>
        {navigation.map((item, idx) => {
          const isCurrentPath = `${cutUrl(pathname)}` === item.path.slice(1);
          const hasNewNotification = newNotificationList?.find(
            (notiItem: any) => notiItem.category === item.text.toUpperCase(),
          );

          // member인 경우 account page 숨김
          if (
            (item.name === 'account' || item.name === 'invoice' || item.name === 'partner') &&
            isNormalLevelUser
          )
            return;

          return (
            <li
              key={idx}
              className={cx(
                'appNav__menu_item',
                {
                  active: isCurrentPath,
                },
                item.name,
              )}
            >
              <NavLink to={item.path} className="appNav__link">
                <img
                  src={item.onIcon}
                  className={cx('appNav__link_img', {
                    active: isCurrentPath,
                  })}
                />
                <img
                  src={item.icon}
                  className={cx('appNav__link_img', {
                    active: !isCurrentPath,
                  })}
                />

                <T>{item.code}</T>
                {!!newNotificationList?.length && !!hasNewNotification && (
                  <span className="appNav__new_icon">N</span>
                )}
              </NavLink>
            </li>
          );
        })}
        {/* MES USER - KPI MENU */}
        {user.canSeeStatistics && (
          <li
            className={cx(
              'appNav__menu_item',
              {
                active: `${cutUrl(pathname)}` === pageUrl.kpi.index.slice(1),
              },
              'kpi',
            )}
          >
            <NavLink to={pageUrl.kpi.index} className="appNav__link">
              <img
                src={icon_nav_on_kpi}
                className={cx('appNav__link_img', {
                  active: `${cutUrl(pathname)}` === pageUrl.kpi.index.slice(1),
                })}
              />
              <img
                src={icon_nav_kpi}
                className={cx('appNav__link_img', {
                  active: `${cutUrl(pathname)}` !== pageUrl.kpi.index.slice(1),
                })}
              />

              <T>NAV_MENU_KPI</T>
            </NavLink>
          </li>
        )}
        {/* SCAN PROCESS PROGRESS */}
        <li className="appNav__scan_progress">
          <ScanProcessContainer />
        </li>
        {process.env.REACT_APP_IS_PRODUCT == '0' && (
          <li className="appNav__test_text">{'[ Test_Ver ]'}</li>
        )}
      </ul>

      <ul className="appNav__menu_list sub">
        {navigationSub.map((item, idx) => {
          const isCurrentPath = `${cutUrl(pathname)}` === item.path.slice(1);
          const hasNewNotification = newNotificationList?.find(
            (notiItem: any) => notiItem.category === item.text.toUpperCase(),
          );

          return (
            <li
              key={idx}
              className={cx(
                'appNav__menu_item',
                {
                  active: isCurrentPath,
                },
                item.name,
              )}
            >
              <NavLink to={item.path} className="appNav__link">
                <img
                  src={item.onIcon}
                  className={cx('appNav__link_img', {
                    active: isCurrentPath,
                  })}
                />
                <img
                  src={item.icon}
                  className={cx('appNav__link_img', {
                    active: !isCurrentPath,
                  })}
                />
                <T>{item.code}</T>
                {!!newNotificationList?.length && !!hasNewNotification && (
                  <span className="appNav__new_icon">N</span>
                )}
                {/* <span className="appNav__new_icon">N</span> */}
              </NavLink>
            </li>
          );
        })}

        <li className="appNav__menu_item logout">
          <Link to={pageUrl.auth.signOut} className="appNav__logout">
            <T>GLOBAL_LOGOUT</T>
          </Link>
        </li>
      </ul>
    </Styled.AppNav>
  );
};

const Styled = {
  AppNav: styled.nav`
    z-index: 1300;
    position: fixed;
    /* margin-top: -${headerHeight}px; */
    width: 200px;
    min-height: 100vh;
    padding-bottom: 70px;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.22);

    .appNav__menu_list {
      .appNav__logo_box {
        height: 80px;
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .appNav__test_text {
        font-size: 12px;
        font-weight: 500;
        color: #ff0000;
        height: 80px;
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &.main {
        .appNav__menu_item {
          padding: 9px 0 9px 33px;
          &:hover,
          &.active {
            background: #ebedf2;
          }
          &.active {
            border-left: 3px solid #323d91;
            a {
              color: #1b2960;
              font-size: 14px;
              font-weight: 500;
            }
          }

          a {
            color: #444;
            font-size: 14px;
          }
        }
      }
      &.sub {
        .appNav__menu_item {
          padding: 6px 0 6px 33px;
          &:not(.logout) {
            &:hover,
            &.active {
              background: #ebedf2;
            }
            &.active {
              border-left: 3px solid #323d91;
              a {
                color: #444;
                font-size: 14px;
                font-weight: 500;
              }
            }
          }
          a {
            color: #888;
            font-size: 14px;
          }
        }
      }
      .appNav__menu_item {
        height: 56px;
        width: 200px;
        position: relative;

        font-size: 14px;
        color: white;
        border-left: 3px solid transparent;

        /* &:hover,
          &.active {
            background: #ebedf2;
          } */
        &.logout {
          /* margin-top: 28px; */
          padding: 22px 0 0 40px;
          height: 100%;
          .appNav__logout {
            font-size: 14px;
            text-decoration: underline;
          }
        }
      }

      /* &.active {
          border-left: 3px solid #323d91;
          a {
            color: #1b2960;
            font-size: 14px;
            font-weight: 500;
          }
        } */

      /* &.dash {
          margin: 16px 25px 16px 15px;
          padding: 0;
          border-top: 1px solid #ffffff;
          opacity: 0.15;
          height: 0;
        } */
      /* } */

      .appNav__link {
        display: flex;
        align-items: center;
        .appNav__link_img {
          display: none;
          margin-right: 16px;
          &.active {
            display: block;
          }
        }
        .appNav__link_arrow {
          position: absolute;
          right: 9px;
        }
        .appNav__new_icon {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          /* right: 10px; */
          right: 15px;
          width: 20px;
          height: 20px;
          background-color: ${color.blue};
          border-radius: 50%;
          font-size: 13px;
          color: white;
          font-weight: 500;
        }
      }
    }
  `,
};

export default AppNav;
